import React from 'react';
import {
  AppBar, Toolbar, Button, IconButton, Drawer, List, ListItemButton,
  ListItemText, Collapse, Menu, MenuItem, Box, useMediaQuery,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../../assets/Images/Logo.png';

const NAV_LINKS = [
  { label: 'Inicio', to: '/' },
];

const SEDES = [
  { label: 'Sant Andreu de la Barca', to: '/santandreu' },
  { label: 'Martorell', to: '/martorell' },
];

const Navbar = () => {
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const [solid, setSolid] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [sedesOpen, setSedesOpen] = React.useState(false);
  const navigate = useNavigate();
  const isMobile = useMediaQuery((t) => t.breakpoints.down('md'));

  React.useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > 20);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const goContact = () => {
    setDrawerOpen(false);
    const scroll = () => {
      const el = document.getElementById('contacto');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    };
    if (document.getElementById('contacto')) scroll();
    else { navigate('/'); setTimeout(scroll, 300); }
  };

  const linkSx = {
    color: '#fff',
    fontFamily: "'Oswald', sans-serif",
    fontWeight: 500,
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    fontSize: '0.95rem',
    px: 1.5,
    '&:hover': { color: '#E63644', backgroundColor: 'transparent' },
  };

  return (
    <AppBar
      position="fixed"
      elevation={solid ? 4 : 0}
      sx={{
        backgroundColor: solid ? '#0E0E10' : 'rgba(14,14,16,0.15)',
        backdropFilter: solid ? 'none' : 'blur(6px)',
        transition: 'background-color 0.35s ease',
        backgroundImage: 'none',
      }}
    >
      <Toolbar sx={{ minHeight: { xs: 64, md: 76 } }}>
        <Box component={Link} to="/" sx={{ display: 'flex', alignItems: 'center', mr: 'auto' }}>
          <Box
            component="img"
            src={logo}
            alt="MesVida"
            sx={{ height: { xs: 40, md: 52 }, width: 'auto', objectFit: 'contain' }}
          />
        </Box>

        {isMobile ? (
          <IconButton edge="end" aria-label="Abrir menú" onClick={() => setDrawerOpen(true)} sx={{ color: '#fff' }}>
            <MenuIcon />
          </IconButton>
        ) : (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            {NAV_LINKS.map((l) => (
              <Button key={l.to} component={Link} to={l.to} sx={linkSx}>{l.label}</Button>
            ))}
            <Button
              sx={linkSx}
              onClick={(e) => setAnchorEl(e.currentTarget)}
              endIcon={<ExpandMore />}
            >
              Sedes
            </Button>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={() => setAnchorEl(null)}
              PaperProps={{ sx: { backgroundColor: '#17171A', color: '#fff', mt: 1 } }}
            >
              {SEDES.map((s) => (
                <MenuItem
                  key={s.to}
                  component={Link}
                  to={s.to}
                  onClick={() => setAnchorEl(null)}
                  sx={{ '&:hover': { color: '#E63644' } }}
                >
                  {s.label}
                </MenuItem>
              ))}
            </Menu>
            <Button
              variant="contained"
              color="secondary"
              onClick={goContact}
              sx={{ ml: 1.5 }}
            >
              Contacto
            </Button>
          </Box>
        )}
      </Toolbar>

      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{ sx: { backgroundColor: '#0E0E10', color: '#fff', width: '78%', maxWidth: 340 } }}
      >
        <List sx={{ pt: 3 }}>
          {NAV_LINKS.map((l) => (
            <ListItemButton key={l.to} component={Link} to={l.to} onClick={() => setDrawerOpen(false)}>
              <ListItemText primaryTypographyProps={{ sx: linkSx }} primary={l.label} />
            </ListItemButton>
          ))}
          <ListItemButton onClick={() => setSedesOpen((v) => !v)}>
            <ListItemText primaryTypographyProps={{ sx: linkSx }} primary="Sedes" />
            {sedesOpen ? <ExpandLess sx={{ color: '#fff' }} /> : <ExpandMore sx={{ color: '#fff' }} />}
          </ListItemButton>
          <Collapse in={sedesOpen} timeout="auto" unmountOnExit>
            <List disablePadding>
              {SEDES.map((s) => (
                <ListItemButton key={s.to} component={Link} to={s.to} onClick={() => setDrawerOpen(false)} sx={{ pl: 4 }}>
                  <ListItemText primaryTypographyProps={{ sx: { ...linkSx, fontSize: '0.85rem' } }} primary={s.label} />
                </ListItemButton>
              ))}
            </List>
          </Collapse>
          <Box sx={{ px: 2, pt: 2 }}>
            <Button fullWidth variant="contained" color="secondary" onClick={goContact}>
              Contacto
            </Button>
          </Box>
        </List>
      </Drawer>
    </AppBar>
  );
};

export default Navbar;
